<template></template>

<script setup>
import { watch } from 'vue'

import { configureEcho, useConnectionStatus } from '@laravel/echo-vue'

import { getAccessToken } from '@/helpers/auth-helper'

import { useDefaultStore } from '@/store/defaultStore'

import { useUserNotifications } from '@/composables/echo/useUserNotifications'
import { useMaintenanceChannel } from '@/composables/echo/useMaintenanceChannel'
import { useHeaderMetrics } from '@/composables/echo/useHeaderMetrics'

configureEcho({
    broadcaster: 'reverb',
    forceTLS: import.meta.env.VITE_NODE_ENV === 'local',
    authEndpoint: `${import.meta.env.VITE_API_URL}/broadcasting/auth`,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    wssPort: import.meta.env.VITE_REVERB_WS_PORT,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    auth: {
        headers: {
            Authorization: `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
        },
    },
    namespace: '',
})

useUserNotifications()
useMaintenanceChannel()
useHeaderMetrics()

const status = useConnectionStatus()
const defaultStore = useDefaultStore()

watch(status, (value) => {
    if (value === 'unavailable' || value === 'failed') {
        defaultStore.setErrorMessage({ message: 'Realtime connection lost. Reconnecting…' })
    }
})
</script>
